import { useOrganization, useUser } from "@clerk/react";
import posthog from "posthog-js";
import { useEffect, useRef } from "react";

export const usePostHogSync = () => {
  const { user } = useUser();
  const { organization } = useOrganization();

  const syncedUserRef = useRef<string | null>(null);
  const syncedOrgRef = useRef<string | null>(null);
  const hasLinkedRef = useRef(false);

  // console.log("syncedUserRef", syncedUserRef.current);
  // console.log("syncedOrgRef", syncedOrgRef.current);
  // console.log("hasLinkedRef", hasLinkedRef.current);

  useEffect(() => {
    // if (import.meta.env.VITE_ENVIRONMENT != "production") return;

    if (user && syncedUserRef.current !== user.id && !hasLinkedRef.current) {
      posthog.alias(user.id); // Simple alias - PostHog handles the rest
      // hasLinkedRef.current = true;
    }

    // Identify user
    if (user && syncedUserRef.current !== user.id) {
      posthog.identify(user.id, {
        email: user.primaryEmailAddress?.emailAddress,
        name: user.fullName,
        firstName: user.firstName,
        lastName: user.lastName,
        username: user.username,
        createdAt: user.createdAt,
        imageUrl: user.imageUrl,
      });

      syncedUserRef.current = user.id;
    }

    // Group by organization
    if (organization && syncedOrgRef.current !== organization.id) {
      posthog.group("organization", organization.id, {
        name: organization.name,
        slug: organization.slug,
        imageUrl: organization.imageUrl,
        createdAt: organization.createdAt,
        membersCount: organization.membersCount,
      });
      syncedOrgRef.current = organization.id;
    }

    if (!user && syncedUserRef.current) {
      posthog.reset();
      syncedUserRef.current = null;
      syncedOrgRef.current = null;
      hasLinkedRef.current = false;
    }
  }, [user?.id, organization?.id]);
};
